export default __webpack_public_path__ + "static/media/en.8ee5d841.png";